export default {
  roles: [],
  role: null,
  permissions: [], 
  pagination: {}
}
